<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <div class="tile">
      <div class="row mb-4">
        <div class="col text-center">
          <h2 class="zero-text p-huge-bold">
            {{ 'mydepot.kwk.headline' | transloco }}
          </h2>
          <p class="mt-4" [innerHTML]="'mydepot.kwk.description' | transloco"></p>
        </div>
      </div>
      <self-service-customer-promotion
        [loggedIn]="kwkFacade.isLoggedIn$ | async"
        [promoLink]="kwkFacade.promoLink$ | async"
        [notYetCustomerMessage]="kwkFacade.notYetCustomer$ | async"
      />
    </div>
  </div>
</div>
